import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { getPurchase } from "../../actions/purchase";
import { getSpecificLocation } from "../../actions/warehouseAction";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
} from "antd";

const { Option } = Select;

const Quickview = ({
  details,
  getPurchase,
  businessprofile,
  getSpecificLocation,
}) => {
  
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [branch, setbranch] = useState([]);
  const [data, setdata] = useState([]);
  const serialcount = useRef(0);
  const count = useRef(0);

  const showDrawer = () => {
    getSpecificLocation(details.location).then((result) => {
      setbranch(result);
    });
    getPurchase(details.id).then((service) => {
      // console.log(service);
      count.current = service.length;
      if (count.current < 10) count.current = 10 - count.current;
      else {
        count.current = 0;
      }
      setdata(service);
      setloading(false);
    });
    console.log(details)
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const renderImage = () => {
      // console.log(businessprofile)
      if (loading) {
        return <Skeleton active />;
      } else {
        return (
          <img
            src={businessprofile.logo}
            style={{
              maxHeight: "60px",
              // right: "0",
            }}
          />
        );
      }
    };
  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((item, index) => {
        // console.log(item);
        serialcount.current = index + 1;
        return (
          <>
            <tr>
              <td>{index + 1}</td>

              <td> {item.Item} </td>
              <td> {item.size} </td>
              {/* {item.details ? (
                <td></td>
              ) : (
                <td>{formatter.format(item.price)}</td>
              )} */}
              <td style={{ textAlign: "center", margin: "auto" }}>
                {item.quantity}
              </td>
              <td>{formatter.format(item.purchase_price)}</td>
              <td>
                {formatter.format(item.purchase_price * item.quantity)}
              </td>
            </tr>
          </>
        );
      });
    }
  };

  const renderblanktables = () => {
    if (loading) {
      return "";
    } else {
      let indexcount = 0;
      return Array.apply(null, Array(count.current)).map(() => {
        indexcount = indexcount + 1;
        return (
          <tr>
            <td>{serialcount.current + indexcount}</td>
            {/* <td></td> */}
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        );
      });
    }
  };

  return (
    <>
      <>
        <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
          List
        </a>
        <Drawer
          width="850"
          onClose={onClose}
          visible={visible}
          // bodyStyle={{ paddingBottom: 80 }}
        >
          <ReactToPrint
            trigger={() => <button>Print this out!</button>}
            content={() => componentRef.current}
          />
          <div style={{ display: "none" }}>
            <div
              ref={componentRef}
              style={{ padding: "10px" }}
              className="invoice_print_fontSize"
            >
              <Row
                style={{
                  borderBottom: "2px solid lightgray",
                  paddingBottom: "5px",
                  marginBottom: "20px",
                }}
              >
                <Col span={15} style={{ textAlign: "left" }}>
                  <small>
                    <div
                      className="d-div"
                      dangerouslySetInnerHTML={{
                        __html: businessprofile.address,
                      }}
                    ></div>
                  </small>
                </Col>

                <Col span={9} style={{ textAlign: "right" }}>
                  <img
                    src={businessprofile.logo}
                    style={{
                      maxHeight: "60px",
                      // right: "0",
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={13}>
                  {details.contact ? (
                    <>
                      {details.Contact[0].name ? (
                        <h4>{details.Contact[0].name}</h4>
                      ) : (
                        ""
                      )}
                      {details.Contact[0].address
                        ? details.Contact[0].address
                        : ""}

                      {details.Contact[0].phone
                        ? "Phone : " + details.Contact[0].phone
                        : ""}
                      <br></br>
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.shipping_address ? (
                    <>
                      {" "}
                      <h3>Shipping Address : </h3>
                      {details.shipping_address}
                    </>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={11}>
                  {/* <h1 style={{ textAlign: "right" }}>{details.status}</h1> */}
                  <Row style={{ margin: "auto", textAlign: "right" }}>
                    <Col span={13}>
                      <h3>PO No.</h3>
                    </Col>
                    <Col span={10} offset={1} style={{ textAlign: "right" }}>
                      {details.purchase_number}
                    </Col>
                  </Row>
                  <Row style={{ margin: "auto", textAlign: "right" }}>
                    <Col span={13}>
                      <h3>Issue Date</h3>
                    </Col>
                    <Col span={10} offset={1} style={{ textAlign: "right" }}>
                      {details.issue_date}
                    </Col>
                  </Row>
                  <Row style={{ margin: "auto" }}>
                    <Col span={13} style={{ textAlign: "right" }}>
                      <h3>Reference</h3>
                    </Col>
                    <Col span={10} offset={1} style={{ textAlign: "right" }}>
                      {details.reference ? details.reference : ""}
                    </Col>
                  </Row>
                </Col>
              </Row>

              <table className="product_table invoice_print_fontSize">
                <tbody>
                  <tr style={{ fontWeight: "500" }}>
                    <td>NO</td>
                    <td>PRODUCT DETAILS</td>
                    <td>SIZE </td>
                    {/* <td>DESIGN CODE</td> */}
                    {/* <td>RATE</td> */}
                    <td>QTY</td>
                    <td>RATE</td>
                    <td>AMOUNT</td>
                  </tr>
                  {renderitems()}
                  {renderblanktables()}
                  <tr style={{ fontWeight: "500" }}>
                    <td></td>
                    <td>TOTAL</td>
                    <td></td>
                    {/* <td>DESIGN CODE</td> */}
                    {/* <td>RATE</td> */}
                    <td>{details.quantity}</td>
                    <td></td>
                    <td>{formatter.format(details.bill)}</td>
                    {/* <td>AMOUNT</td> */}
                  </tr>
                </tbody>
              </table>
              <Divider />
              <Row style={{ minHeight: "20px" }}>
                <Col span={24} style={{ textAlign: "left" }}>
                  {details.remarks ? (
                    <>
                      {" "}
                      <h3>Note : </h3>
                      <div
                        dangerouslySetInnerHTML={{ __html: details.remarks }}
                      ></div>
                    </>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} style={{ textAlign: "left" }}>
                  {/* <h3
                style={{
                  borderTop: "2px solid black",
                  display: "inline-block",
                }}
              >
                ACCOUNT SIGNATURE
              </h3> */}
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  <h3
                    style={{
                      marginBottom: "0px",
                      marginTop: "10px",
                      padding: "0px",
                      borderTop: "2px solid black",
                      // width: "50%",
                      display: "inline-block",
                    }}
                  >
                    RECEIVER SIGNATURE
                  </h3>
                  <br></br>
                  <small>(WITH DATE)</small>
                </Col>
              </Row>
            </div>
          </div>
          <Row
            style={{
              borderBottom: "2px solid lightgray",
              paddingBottom: "5px",
              marginBottom: "20px",
            }}
          >
            <Col span={15} style={{ paddingTop: "10px" }}>
              <small>
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{
                    __html: businessprofile.address,
                  }}
                ></div>
              </small>
            </Col>

            <Col span={9} style={{ textAlign: "right" }}>
              <img
                src={businessprofile.logo}
                style={{
                  maxHeight: "60px",
                  // right: "0",
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col span={13}>
              {/* <h3>Supplier details</h3> */}
              {details.contact ? (
                <>
                  {details.Contact[0].name ? (
                    <h4>{details.Contact[0].name}</h4>
                  ) : (
                    ""
                  )}
                  {details.Contact[0].address ? details.Contact[0].address : ""}

                  {details.Contact[0].phone
                    ? "Phone : " + details.Contact[0].phone
                    : ""}
                  <br></br>
                  <br></br>
                </>
              ) : (
                ""
              )}
              {details.shipping_address ? (
                <>
                  {" "}
                  <h3>Shipping Address : </h3>
                  {details.shipping_address}
                </>
              ) : (
                ""
              )}
            </Col>
            <Col span={11}>
              <Row style={{ margin: "auto", textAlign: "right" }}>
                <Col span={13}>
                  <h3>PO No.</h3>
                </Col>
                <Col span={10} offset={1} style={{ textAlign: "right" }}>
                  {details.purchase_number ? (
                    <h4>{details.purchase_number}</h4>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>

              <Row style={{ margin: "auto", textAlign: "right" }}>
                <Col span={13}>
                  <h3>Issue Date</h3>
                </Col>
                <Col span={10} offset={1} style={{ textAlign: "right" }}>
                  {details.issue_date}
                </Col>
              </Row>
              <Row style={{ margin: "auto" }}>
                <Col span={13} style={{ textAlign: "right" }}>
                  <h3>Reference</h3>
                </Col>
                <Col span={10} offset={1} style={{ textAlign: "right" }}>
                  {details.reference ? details.reference : ""}
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider />
          <table className="product_table">
            <tbody>
              <tr style={{ fontWeight: "500" }}>
                <td>NO</td>
                <td>PRODUCT DETAILS</td>
                <td>SIZE </td>
                {/* <td>DESIGN CODE</td> */}
                {/* <td>RATE</td> */}
                <td>QTY</td>
                <td>RATE</td>
                <td>AMOUNT</td>
                {/* <td>AMOUNT</td> */}
              </tr>
              {renderitems()}
              {renderblanktables()}
              <tr style={{ fontWeight: "500" }}>
                    <td></td>
                    <td>TOTAL</td>
                    <td></td>
                    {/* <td>DESIGN CODE</td> */}
                    {/* <td>RATE</td> */}
                    <td>{details.quantity}</td>
                    <td></td>
                    <td>{formatter.format(details.bill)}</td>
                    {/* <td>AMOUNT</td> */}
                  </tr>
            </tbody>
          </table>

          <Row>
            <Col span={14}>
              <br style={{ minHeight: "40vh" }}></br>
              {details.remarks ? (
                <>
                  {" "}
                  <h3>Note : </h3>
                  <div
                    dangerouslySetInnerHTML={{ __html: details.remarks }}
                  ></div>
                </>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row style={{ minHeight: "80px" }}>
            <Col span={12} style={{ textAlign: "left" }}>
              {/* <img
                src={businessprofile.signature}
                style={{
                  maxHeight: "80px",
                  left: "0",
                }}
              /> */}
            </Col>
            <Col span={12} style={{ textAlign: "center" }}></Col>
          </Row>
          <Row>
            <Col span={12} style={{ textAlign: "left" }}></Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <h3
                style={{
                  marginBottom: "-10px",
                  padding: "0px",
                  borderTop: "2px solid black",
                  // width: "50%",
                  display: "inline-block",
                }}
              >
                RECEIVER SIGNATURE
              </h3>
              <br></br>
              <small>(WITH DATE)</small>
            </Col>
          </Row>
        </Drawer>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, { getPurchase, getSpecificLocation })(
  Quickview
);
